import type { FaireProductEntity } from "../../entity_types/product";

export const p_4567dtrdef: FaireProductEntity = {
  token: "p_4567dtrdef",
  type: "product",
  name: "Flying Cork Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3654b8e61fc6a3eb8c8c7830033f76bff405b417a0ba04fa0ca3284ef8ee1d3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c46f7aca9ce08e8799e8b5d8f46fde565e92e23b26c7f053680dcceef3098377.jpeg",
    "https://cdn.faire.com/fastly/67bc15fc4ee5de72a6fbd970fc730446a1227343235880b279609beda21f5049.jpeg",
    "https://cdn.faire.com/fastly/e4773868b3cbe547c9821f522f525d417b81971d08ffa1c1b0085a5335cab374.jpeg",
    "https://cdn.faire.com/fastly/2f81d08a0533d3824997ab80e951293a9c1b97f7a226ad06ee834710edc8b77c.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:47.373Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
